import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlockStack, Box, InlineStack, Spinner, Text } from '@shopify/polaris';
/** Centered spinner for async sections. Prefer over blank screens. */
export function LoadingState({ label = 'Loading' }) {
    return (_jsx(Box, { padding: "800", children: _jsx(InlineStack, { align: "center", children: _jsxs(BlockStack, { gap: "300", inlineAlign: "center", children: [_jsx(Spinner, { accessibilityLabel: label, size: "large" }), _jsx(Text, { as: "span", tone: "subdued", children: label })] }) }) }));
}
//# sourceMappingURL=LoadingState.js.map